<div class="wrap qo-flex-col-top-left punch-popup">
	<h1
		class="qo-padding20">{{!data.punchedIn ? ('PUNCH_CLOCK.START_PUNCH' | translate) : ('PUNCH_CLOCK.STOP_PUNCH' | translate)}}</h1>
	<div class="line-separator"></div>
	<div class="qo-padding20">
		<div class="qo-flex-col-top-left medium-text">
			<div class="qo-flex-row-top-left">
				{{'PUNCH_CLOCK.START_OF_PUNCH' | translate}}:
				<div class="qo-margin-left10  bold">
					{{data.punchedIn ? data.shift.punch_start.localDate.format('HH:mm:ss') : dateNow | smLocalDate: 'HH:mm:ss'}}
				</div>
			</div>
			<div class="qo-flex-row-top-left qo-margin-top25" *ngIf="data.punchedIn">
				{{'PUNCH_CLOCK.END_OF_PUNCH' | translate}}:
				<div
					class="qo-margin-left10 bold">{{dateNow | smLocalDate: 'HH:mm:ss'}}</div>
			</div>
		</div>
	</div>
	<div class="line-separator"></div>
	<form [formGroup]="form">
		<div
			*ngIf="!data.punchedIn"
			class="qo-padding20 qo-margin-top20"
		>
			<qo-form-block
				[label]="'GROUPS.GROUPS' | translate"
			>
				<qo-input-select
					[options]="groupSelectOptions"
					[placeholder]="'PUNCH_CLOCK.SELECT_GROUP' | translate"
					[formControl]="selectedGroupControl"
				></qo-input-select>
			</qo-form-block>
		</div>
		<div
			*ngIf="data.punchedIn"
			class="qo-padding20 width100 qo-margin-top20"
		>
			<label class="qo-label">
				{{'ACTIONS.NOTE' | translate}}
				<textarea
					class="qo-input text-area"
					formControlName="punch_note"
					[rows]="5"
				>
			</textarea>
			</label>
		</div>
	</form>
	<div class="qo-padding20 qo-margin-top20 qo-flex-row-space-between btn-sticky-sm bottom-buttons">
		<button
			class="qo-button-standard qo-grey"
			(click)="close()"
		>
			{{'cancel_all' | translate}}
		</button>
		<button
			[disabled]="!data.punchedIn && form.invalid"
			[ngClass]="data.punchedIn ? 'qo-button-standard qo-no' : 'qo-button-standard qo-primary'"
			(click)="punch()"
		>
			<qo-icon
				[icon]="data.punchedIn ? EQORebrandIcon.stop_circle_dark: EQORebrandIcon.play_dark"
				[color]="EQORebrandColor.WHITE"
			></qo-icon>
			{{data.punchedIn ? ('PUNCH_CLOCK.STOP_PUNCH' | translate) : ('PUNCH_CLOCK.START_PUNCH' | translate)}}
		</button>
	</div>
</div>
